export default __webpack_public_path__ + "static/Compliance-1256b6b30cfaaccc046ccd053ea83ea6.png";